<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>1ENG Second Edition: Space Systems: Patterns and Cycles - Downloads and Resources</h3>

      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F1ENG-2E_Activities_1-5_08212024.zip?alt=media&token=17278889-dfba-46a4-9b8e-13b86b0b4d36" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1xmreKHbbkVmNRqmsPrJaUfxiJGrD7X95qAE0Sglsf-Y/copy" target="_blank">1ENG Second Edition: Space Systems: Patterns and Cycles Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/18b0SVhYZAbRcWUkhNSk9hkYL-CgAHyN5/view" target="_blank">1ENG Second Edition: Space Systems: Patterns and Cycles Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/173C9sMlvGR5t_iPUgoXdiHT9yhVbnVQGTJxsqmv1QpA/copy" target="_blank">1ENG Second Edition: Space Systems: Patterns and Cycles Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F1ENG-2E_PostAssessment_01182022.pdf?alt=media&token=a9092c46-eb35-48e4-b1bd-f938a79b8ad9" target="_blank">1ENG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F1ENG-2E_PostAssessment_Spanish_05312022.pdf?alt=media&token=68e1a981-aa83-472b-8cfb-bb05a5df0250" target="_blank">1ENG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1Nc0Qob5t9sWByne5I9klF812vVQ9If-TGze0prKLtAY/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/16xSgZ7cczOUAZZ5xlG10qYe9IX8XlGfB4mgTrustS4w/copy" target="_blank">Objects in the Sky t-chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1FjNa5N9J6XksLh2nj3WvzJky55YVyCz349Y8spLxyk4/copy" target="_blank">1ENG Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/14_PQzn-7c4dUYdKJi8n6dDxqGVkAehr4ihtS4KSLTdA/copy" target="_blank">Day and Night Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1UlCPO9yBz58Y33n_ftVUeG_ZEJiV5dH2lm19Qz9Gxak/copy" target="_blank">Moon Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1gP3ABdR6E-1j1klH5x7ltflOKToRDH_PWSzC88Eqz4E/copy" target="_blank">When the Street Lights Come On!</a></li>
          <li><a href="https://docs.google.com/presentation/d/1q7EJvPT1LtA85iddrr5hzKf6fhm7L4z3HPvej6EmQrw/copy" target="_blank">Word Sort Cards - Lesson 2B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1rxatO47nbvFffcvIn_l18wGHdGGDk4APdM8amSYaQkc/copy" target="_blank">Model Explaining Different Moon Shapes</a></li>
          <li><a href="https://docs.google.com/presentation/d/16n0GQ1qcyxqxdyt4Cwl_1eYeZGcd3W1PmEevG06FyXM/copy" target="_blank">Word Sort Cards - Lesson 3C</a></li>
          <li><a href="https://docs.google.com/document/d/127rM1yb1MxijzVbx3j2qo9IPgs0KwvQ0Q8_M4e3thvs/copy" target="_blank">Star Chart</a></li>

          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      </div>

    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>